import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when a user clicks on the Exploring the Professional Hub tutorial on the Help page
 * Event: dental_portal:help:professional_hub_tutorial_clicked
 */
export function fireHelpProfessionalHubTutorialClicked(): void {
  PosthogService.getInstance().track('dental_portal:help:professional_hub_tutorial_clicked');
}
